<div class="row mb-3 mt-2">
   <!-- Commented on 20th April 2026 for the breadcrumb changes -->
  <!-- <div class="card-header bg-white py-3" [hidden]="showselector">
    <div>
      <div class="col-6 mb-2">
        <label for="name" class="form-label">Plant:</label>
        <select class="form-select border border-dark" name="plantid" (change)="getSelectedId($event)">
          <option [selected]>Select Plant</option>
          <option *ngFor="let plant of plants" [value]="plant.Id">
            {{ plant.Name }}
          </option>
        </select>
      </div>

      <div class="col-6">
        <label for="train" class="form-label">Train:</label>
        <select class="form-select border border-dark" name="trainid" (change)="getSelectedTrainId($event)">
          <option [selected]>Select Train</option>
          <option *ngFor="let train of trains" [value]="train.Id">
            {{ train.Name }}
          </option>
        </select>
      </div>
    </div>
  </div> -->

  <label for="stage" class="form-label" style="margin-left: 10px;">Stages</label>
</div>
<div class="col-4 m-1">
  <select class="form-select border border-dark"  name="stage"
  *ngIf="+trainDetails.Stages == 1" (change)="onOptionSelected($event)">
  <option *ngFor="let stages of stageTotal" [value]="stages.Id">
    {{ stages.Name }}
  </option>
</select>
    <select class="form-select border border-dark"  name="stage"
    *ngIf="+trainDetails.Stages == 2" (change)="onOptionSelected($event)">
    <option *ngFor="let stages of stage2" [value]="stages.Id">
      {{ stages.Name }}
    </option>
  </select> 

 <select class="form-select border border-dark"  name="stage"
    *ngIf="+trainDetails.Stages == 3" (change)="onOptionSelected($event)">
    <option *ngFor="let stages of stage3" [value]="stages.Id" >
      {{ stages.Name }}
    </option>
  </select>
</div>
<div class="row  mb-3 mt-2">
  <div class="col-1"></div>
  <div class="col-5">
      <button type="button" class="btn" (click)="showGraph()">
          Generate primary Graph
      </button>
  </div>
</div>
<div class="row" style="text-align: center;">
  <h4 [innerHtml]="graphName"></h4>
  <div id="plot" style="border:deepskyblue;" style="height: 700px;width:NewWidth">
  </div>
  <hr class="mb-6" />
  <h4 [innerHtml]="graphName2"></h4>
  <div id="plot2" style="border:red;" style="height: 700px;width:NewWidth">
  </div>
  <hr class="mb-6" />
  <h4 [innerHtml]="graphName3"></h4>
  <div id="plot3" style="border:green;" style="height: 700px;width:NewWidth">
  </div>

</div>